module.exports = __webpack_public_path__ + "img/logo-light.07ffa568.png";